import { CommonModule } from '@angular/common';
import { Component, input, output } from '@angular/core';

export interface NavMenuItem {
  /** メニューアイコン画像のパス */
  iconSrc: string;
  /** メニューテキスト */
  label: string;
  /** クリック時のアクション識別子 */
  action: string;
}

@Component({
  selector: 'app-nav-menu',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './nav-menu.component.html',
  styleUrl: './nav-menu.component.scss',
})
export class NavMenuComponent {
  /** メニューの表示/非表示 */
  isOpen = input<boolean>(false);

  /** メニュー項目一覧 */
  items = input<NavMenuItem[]>([]);

  /** 閉じるボタン押下イベント */
  closeMenu = output<void>();

  /** メニュー項目クリックイベント */
  itemClick = output<string>();

  onItemClick(action: string): void {
    this.itemClick.emit(action);
    this.closeMenu.emit();
  }
}
